import { render, staticRenderFns } from "./ClaimDetailTable.vue?vue&type=template&id=2769baf8"
import script from "./ClaimDetailTable.vue?vue&type=script&lang=js"
export * from "./ClaimDetailTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports